import { render, staticRenderFns } from "./materialDetails.vue?vue&type=template&id=4945d563&scoped=true"
import script from "./materialDetails.vue?vue&type=script&lang=js"
export * from "./materialDetails.vue?vue&type=script&lang=js"
import style0 from "./materialDetails.vue?vue&type=style&index=0&id=4945d563&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945d563",
  null
  
)

export default component.exports